import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";

export default function InputSettings({
  selectedInput,
  setSelectedInput,
  deviceID,
}) {
  const [input, setInput] = useState();

  useEffect(() => {
    setInput(selectedInput);
  }, []);

  useEffect(() => {
    if (input) {
      console.log(input);
    }
  }, [input]);

  return (
    <div>
      {input && (
        <>
          <div className="inputSettingsHeading">
            Edit Input: {input.inputID}
          </div>
          <div className="sectionSpacer">
            <div className="listLineTop"></div>
            <div className="sectionSpacer">
              <div className="inputSettingsFlexField">
                <div>Enabled:</div>
                <FontAwesomeIcon
                  className={`inputSettingsBoolIcon ${
                    input.enabled ? "enabled" : ""
                  }`}
                  icon={faPowerOff}
                />
              </div>
            </div>
            <div className="listLine"></div>
            <div className="sectionSpacer">
              <div className="inputSettingsFlexField">
                <div>Type:</div>
                <div className="inputSettingsToggleOptionsFlex">
                  <div
                    className={`inputSettingsToggleOption ${
                      input.type === "pump" ? "selected" : ""
                    }`}
                  >
                    Pump
                  </div>
                  <div
                    className={`inputSettingsToggleOption ${
                      input.type === "other" ? "selected" : ""
                    }`}
                  >
                    Other
                  </div>
                </div>
              </div>
            </div>
            <div className="listLine"></div>
          </div>
        </>
      )}
    </div>
  );
}
